import { render, staticRenderFns } from "./ListingPageTwo.vue?vue&type=template&id=5b2f0f57&scoped=true&"
import script from "./ListingPageTwo.vue?vue&type=script&lang=js&"
export * from "./ListingPageTwo.vue?vue&type=script&lang=js&"
import style0 from "./ListingPageTwo.vue?vue&type=style&index=0&id=5b2f0f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f0f57",
  null
  
)

export default component.exports